// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Full-screen loader container with cosmic background */
.loader-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: radial-gradient(circle, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 1) 100%),
    url('https://www.transparenttextures.com/patterns/stardust.png'); /* Starry background */
  background-size: 100% 100%;
  animation: moveBackground 20s linear infinite; /* Moving background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  overflow: hidden;
}

/* Timer to show percentage */
.timer {
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: 3rem;
  color: #fff;
  font-weight: bold;
  transform: translate(-50%, -50%);
  z-index: 2;
}

/* Orbiting Planet (removed) */

/* Starry background effect with visible twinkling stars */
.stars {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url('https://www.transparenttextures.com/patterns/stardust.png');
  animation: twinkleStars 1.5s infinite ease-in-out;
  z-index: 1;
  opacity: 0.8;
}

/* Nebula effect with increased opacity */
.nebula {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url('https://www.transparenttextures.com/patterns/white-lightning.png');
  opacity: 0.6;
  animation: fadeNebula 6s infinite alternate;
  z-index: 0;
}

/* Smooth Circular Progress Bar */
.loader-circle {
  position: relative;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  border: 5px solid #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.progress {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: conic-gradient(#ff7f50 0%, transparent 0);
  border-radius: 50%;
  z-index: 2;
}

/* Animation for moving background */
@keyframes moveBackground {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 100% 100%;
  }
}

/* Twinkling stars effect */
@keyframes twinkleStars {
  0%, 100% {
    opacity: 0.8;
  }
  50% {
    opacity: 1;
  }
}

/* Fade-in effect for loader container */
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

/* Nebula fading animation */
@keyframes fadeNebula {
  0% {
    opacity: 0.4;
  }
  100% {
    opacity: 0.8;
  }
}
`, "",{"version":3,"sources":["webpack://./src/loader.css"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb;oEACkE,EAAE,sBAAsB;EAC1F,0BAA0B;EAC1B,6CAA6C,EAAE,sBAAsB;EACrE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,gCAAgC;EAChC,UAAU;AACZ;;AAEA,8BAA8B;;AAE9B,0DAA0D;AAC1D;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,4EAA4E;EAC5E,iDAAiD;EACjD,UAAU;EACV,YAAY;AACd;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mFAAmF;EACnF,YAAY;EACZ,2CAA2C;EAC3C,UAAU;AACZ;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,kBAAkB;EAClB,UAAU;AACZ;;AAEA,oCAAoC;AACpC;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,8BAA8B;EAChC;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF","sourcesContent":["/* Full-screen loader container with cosmic background */\r\n.loader-container {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  background: radial-gradient(circle, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 1) 100%),\r\n    url('https://www.transparenttextures.com/patterns/stardust.png'); /* Starry background */\r\n  background-size: 100% 100%;\r\n  animation: moveBackground 20s linear infinite; /* Moving background */\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 9999;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Timer to show percentage */\r\n.timer {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  font-size: 3rem;\r\n  color: #fff;\r\n  font-weight: bold;\r\n  transform: translate(-50%, -50%);\r\n  z-index: 2;\r\n}\r\n\r\n/* Orbiting Planet (removed) */\r\n\r\n/* Starry background effect with visible twinkling stars */\r\n.stars {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: url('https://www.transparenttextures.com/patterns/stardust.png');\r\n  animation: twinkleStars 1.5s infinite ease-in-out;\r\n  z-index: 1;\r\n  opacity: 0.8;\r\n}\r\n\r\n/* Nebula effect with increased opacity */\r\n.nebula {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: url('https://www.transparenttextures.com/patterns/white-lightning.png');\r\n  opacity: 0.6;\r\n  animation: fadeNebula 6s infinite alternate;\r\n  z-index: 0;\r\n}\r\n\r\n/* Smooth Circular Progress Bar */\r\n.loader-circle {\r\n  position: relative;\r\n  width: 150px;\r\n  height: 150px;\r\n  border-radius: 50%;\r\n  border: 5px solid #fff;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  overflow: hidden;\r\n}\r\n\r\n.progress {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: conic-gradient(#ff7f50 0%, transparent 0);\r\n  border-radius: 50%;\r\n  z-index: 2;\r\n}\r\n\r\n/* Animation for moving background */\r\n@keyframes moveBackground {\r\n  0% {\r\n    background-position: 0 0;\r\n  }\r\n  100% {\r\n    background-position: 100% 100%;\r\n  }\r\n}\r\n\r\n/* Twinkling stars effect */\r\n@keyframes twinkleStars {\r\n  0%, 100% {\r\n    opacity: 0.8;\r\n  }\r\n  50% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n/* Fade-in effect for loader container */\r\n@keyframes fadeIn {\r\n  0% {\r\n    opacity: 0;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n/* Nebula fading animation */\r\n@keyframes fadeNebula {\r\n  0% {\r\n    opacity: 0.4;\r\n  }\r\n  100% {\r\n    opacity: 0.8;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
